import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/system/migration/upgrade-to-v9/upgrade-to-v9.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
